import { clearPersonalNumber } from './clearPersonalNumber';

const PNRe = /(\d{4})$/;

export const fastFormatPersonalNumber = (pn?: string) =>
  pn?.replace(PNRe, '-$1');

export const formatPersonalNumber = (pn: string) =>
  fastFormatPersonalNumber(clearPersonalNumber(pn));
